var React = require('react');

function Dial90 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0705076 1000H500C776.108 1000 1000 776.108 1000 500C1000 223.822 776.108 0 500 0C223.892 0 -1.52588e-05 223.892 -1.52588e-05 500L0.0705076 1000Z","fill":"currentColor"}));
}

Dial90.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000","fill":"none"};

module.exports = Dial90;

Dial90.default = Dial90;
